<template>
  <component :is="`${type}-comp`" v-bind="$props" v-on="$listeners"/>
</template>

<script>
import Vue from 'vue';
import props from './props';

export default Vue.extend({
  components: {
    'main-comp': () => import('./main.vue'),
    'language-comp': () => import('./language.vue'),
    'qa-comp': () => import('./qa.vue'),
    'evaluation-comp': () => import('./evaluation.vue'),
    'document-comp': () => import('./document.vue'),
    'industry-comp': () => import('./industry.vue'),
  },
  props: {
    ...props,
    type: {
      type: String,
      default: () => String('main'),
    },
  },
});
</script>

<style lang="scss" scoped>

</style>
